import { useCallback, useEffect } from "react";

const useOnClickOutside = (ref, callback) => {
  const handleCallBack = useCallback(
    // we will run the callback args when the ref is initialized
    (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    },
    [ref, callback]
  );
  // we will wrap this in useCallback to optimize this function

  useEffect(() => {
    document.addEventListener("click", handleCallBack);
    document.addEventListener("mousedown", handleCallBack);
    return () => {
      document.removeEventListener("click", handleCallBack);
      document.removeEventListener("mousedown", handleCallBack);
    };
  }, [handleCallBack]);
};

export { useOnClickOutside };
